import {
  Box,
  Button,
  Checkbox,
  Grid2,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SuccessModal from "../../utils/SuccessModal";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 2.5 + ITEM_PADDING_TOP,
      width: 150,
      background: "#EBF3FD",
    },
  },
};

const EditTenderApprover = () => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState();
  const handleClose = () => setOpen(false);
  const [errors, setErrors] = useState({});
  const { tenderId } = useParams();
  const [draft, setDraft] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const [approvers, setApprovers] = useState({
    purchaseHead: "",
    technicalHead: "",
    financeHead: "",
  });
  const [approversName, setApproversName] = useState({
    purchaseHead: "",
    technicalHead: "",
    financeHead: "",
  });
  const [noOfOpeners, setNoOfOpeners] = useState();
  const [openers, setOpeners] = useState([]);
  const [openersName, setOpenersName] = useState([]);
  const [awardees, setAwardees] = useState({
    awardee1: "",
    awardee2: "",
  });
  const [awardeesName, setAwardeesName] = useState({
    awardee1: "",
    awardee2: "",
  });
  const [orgUsers, setOrgUsers] = useState();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);

  useEffect(() => {
    const getOrgUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/all?username=${user.username}`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        setOrgUsers(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getOrgUsers();
  }, []);

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        setDraft(res.data);

        if (res.data) {
          const newApprovers = {
            purchaseHead: "",
            technicalHead: "",
            financeHead: "",
          };
          const newApproversNames = {
            purchaseHead: "",
            technicalHead: "",
            financeHead: "",
          };

          const newOpeners = [];
          const newOpenersName = [];

          const newAwardees = {
            awardee1: "",
            awardee2: "",
          };
          const newAwardeesName = {
            awardee1: "",
            awardee2: "",
          };

          res.data.approvers.forEach((a) => {
            if (a.approver.userRoleName === "PURCHASE_HEAD") {
              newApprovers.purchaseHead = a.approver.email;
              newApproversNames.purchaseHead = a.approver.name;
            }
            if (a.approver.userRoleName === "TECHNICAL_HEAD") {
              newApprovers.technicalHead = a.approver.email;
              newApproversNames.technicalHead = a.approver.name;
            }
            if (a.approver.userRoleName === "FINANCE_HEAD") {
              newApprovers.financeHead = a.approver.email;
              newApproversNames.financeHead = a.approver.name;
            }
          });
          setApproversName(newApproversNames);
          setApprovers(newApprovers);
          if (res.data && res.data.openers && res.data.openers.length > 0) {
            setNoOfOpeners(res.data.openers[0].noOfOpeners);
            res.data.openers.forEach((o) => {
              newOpeners.push(o.opener.email);
              newOpenersName.push(o.opener.name);
            });
          }
          setOpenersName(newApproversNames);
          setOpeners(newOpeners);
          res.data.tenderAwardees.forEach((t) => {
            newAwardees.awardee1 = t.awardee1?.email || "";
            newAwardeesName.awardee1 = t.awardee1?.name || "";
            newAwardees.awardee2 = t.awardee2.email;
            newAwardeesName.awardee2 = t.awardee2.name;
          });
          setAwardeesName(newAwardeesName);
          setAwardees(newAwardees);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getTender();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    // Approvers
    if (isEmpty(approvers.purchaseHead)) {
      newErrors.purchaseHead = "Purchase Head is required";
    }

    if (isEmpty(approvers.technicalHead)) {
      newErrors.technicalHead = "Technical Head is required";
    }

    if (isEmpty(approvers.financeHead)) {
      newErrors.financeHead = "Finance Head is required";
    }

    // Openers
    if (!openers || openers.length === 0) {
      newErrors.openers = "Openers are required";
    }

    // Awardees
    // if (isEmpty(awardees.awardee1)) {
    //   newErrors.awardee1 = "Awardee 1 is required";
    // }

    if (isEmpty(awardees.awardee2)) {
      newErrors.awardee2 = "Awardee 2 is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    if (!Array.isArray(openers) || noOfOpeners != openers.length) {
      alert("Choose correct number of bid openers");
      return;
    }
    try {
      setBtnLoading(true)
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/tender/update-approver?tenderId=${tenderId}`,
        {
          username: user.username,
          approvers: [
            approvers.purchaseHead,
            approvers.technicalHead,
            approvers.financeHead,
          ],
          noOfOpeners: noOfOpeners,
          openers: openers,
          awardee1: awardees.awardee1,
          awardee2: awardees.awardee2,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      setOpen(true);
      setMsg("Tender Approvers Updated");
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false)
    }
  };

  const handleApproversChange = (e) => {
    const { name, value } = e.target;
    setApprovers((prev) => ({ ...prev, [name]: value }));
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleOpenersChange = (e) => {
    const {
      target: { value },
    } = e;
    setOpeners(typeof value === "string" ? value.split(",") : value);
    setErrors({ ...errors, openers: "" });
  };

  const handleAwardeeChange = (e) => {
    const { name, value } = e.target;
    setAwardees((prev) => ({ ...prev, [name]: value }));
    setErrors({ ...errors, [e.target.name]: "" });
  };
  const handleBack = () => {
    navigate("/dashboard");
  };
  return (
    <div>
      <Typography variant="h4">Select Approvers</Typography>
      <Box className="dashboard-container" px={10}>
        <Typography className="form-title">Select Approvers</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="purchaseHead">Purchase Head</label>
            <Select
              className={`${errors?.purchaseHead && "input-error"}`}
              name="purchaseHead"
              id="purchaseHead"
              onChange={handleApproversChange}
              value={approvers.purchaseHead}
              renderValue={(selected) => {
                const selectedUser = orgUsers?.find(
                  (user) => user.email === selected
                );
                return selectedUser?.name || "Choose";
              }}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "1px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {approvers.purchaseHead === "" && (
                <MenuItem value="">Choose</MenuItem>
              )}
              {approvers.purchaseHead !== "" && (
                <MenuItem value={approvers.purchaseHead} disabled>
                  {approversName.purchaseHead}
                </MenuItem>
              )}
              {orgUsers &&
                orgUsers
                  .filter(
                    (user) =>
                      user.userRoleName === "PURCHASE_HEAD" &&
                      user.email !== approvers.purchaseHead
                  )
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
            {errors?.purchaseHead && (
              <p className="error">{errors?.purchaseHead}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="technicalHead">Tech Head</label>
            <Select
              className={`${errors?.technicalHead && "input-error"}`}
              name="technicalHead"
              id="technicalHead"
              value={approvers.technicalHead}
              renderValue={(selected) => {
                const selectedUser = orgUsers?.find(
                  (user) => user.email === selected
                );
                return selectedUser?.name || "Choose";
              }}
              onChange={handleApproversChange}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "1px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {approvers.technicalHead === "" && (
                <MenuItem value="">Choose</MenuItem>
              )}
              {approvers.technicalHead !== "" && (
                <MenuItem value={approversName.technicalHead} disabled>
                  {approversName.technicalHead}
                </MenuItem>
              )}
              {orgUsers &&
                orgUsers
                  .filter(
                    (user) =>
                      user.userRoleName === "TECHNICAL_HEAD" &&
                      user.email !== approvers.technicalHead
                  )
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
            {errors?.technicalHead && (
              <p className="error">{errors?.technicalHead}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="financeHead">Finance Head</label>
            <Select
              className={`${errors?.financeHead && "input-error"}`}
              name="financeHead"
              id="financeHead"
              value={approvers.financeHead}
              renderValue={(selected) => {
                const selectedUser = orgUsers?.find(
                  (user) => user.email === selected
                );
                return selectedUser?.name || "Choose";
              }}
              onChange={handleApproversChange}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "1px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {approvers.financeHead === "" && (
                <MenuItem value="">Choose</MenuItem>
              )}
              {approvers.financeHead !== "" && (
                <MenuItem value={approvers.financeHead} disabled>
                  {approversName.financeHead}
                </MenuItem>
              )}
              {orgUsers &&
                orgUsers
                  .filter(
                    (user) =>
                      user.userRoleName === "FINANCE_HEAD" &&
                      user.email !== approvers.financeHead
                  )
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
            {errors?.financeHead && (
              <p className="error">{errors?.financeHead}</p>
            )}
          </Grid2>
        </Grid2>
      </Box>

      <Box className="dashboard-container" px={10}>
        <Typography className="form-title">Simultaneous Opening Bid</Typography>
        <div className="btn-container" style={{ gap: 50 }}>
          {[2, 3, 4, 5].map((num) => (
            <div
              key={num}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <input
                type="radio"
                name="openers"
                id={`opener-${num}`}
                value={num}
                checked={noOfOpeners == num}
                onChange={() => setNoOfOpeners(num)}
              />
              <label htmlFor={`opener-${num}`}>{num}</label>
            </div>
          ))}
        </div>
        <Grid2 container columnSpacing={2} mt={5}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="coo">COO</label>
            <Select
              labelId="coo"
              name="coo"
              id="coo"
              multiple
              value={openers}
              renderValue={(selected) =>
                selected
                  .map((email) => {
                    const user = orgUsers?.find(
                      (u) => u.email === email && u.userRoleName === "COO"
                    );
                    return user?.name || "";
                  })
                  .filter(Boolean)
                  .join(", ")
              }
              onChange={handleOpenersChange}
              input={<OutlinedInput />}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                p: 0,
                borderRadius: "7px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {orgUsers &&
                orgUsers
                  .filter((user) => user.userRoleName === "COO")
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      <Checkbox
                        size="small"
                        defaultChecked={openers.includes(user.email)}
                      />
                      <ListItemText primary={user.name} />
                    </MenuItem>
                  ))}
            </Select>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="cfo">CFO</label>
            <Select
              labelId="cfo"
              name="cfo"
              id="cfo"
              multiple
              value={openers}
              renderValue={(selected) =>
                selected
                  .map((email) => {
                    const user = orgUsers?.find(
                      (u) => u.email === email && u.userRoleName === "CFO"
                    );
                    return user?.name || "";
                  })
                  .filter(Boolean)
                  .join(", ")
              }
              onChange={handleOpenersChange}
              input={<OutlinedInput />}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                p: 0,
                borderRadius: "7px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {orgUsers &&
                orgUsers
                  .filter((user) => user.userRoleName === "CFO")
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      <Checkbox
                        size="small"
                        defaultChecked={openers.includes(user.email)}
                      />
                      <ListItemText primary={user.name} />
                    </MenuItem>
                  ))}
            </Select>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ceo">CEO</label>
            <Select
              labelId="ceo"
              name="ceo"
              id="ceo"
              multiple
              value={openers}
              renderValue={(selected) =>
                selected
                  .map((email) => {
                    const user = orgUsers?.find(
                      (u) => u.email === email && u.userRoleName === "CEO"
                    );
                    return user?.name || "";
                  })
                  .filter(Boolean)
                  .join(", ")
              }
              onChange={handleOpenersChange}
              input={<OutlinedInput />}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                p: 0,
                borderRadius: "7px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {orgUsers &&
                orgUsers
                  .filter((user) => user.userRoleName === "CEO")
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      <Checkbox
                        size="small"
                        defaultChecked={openers.includes(user.email)}
                      />
                      <ListItemText primary={user.name} />
                    </MenuItem>
                  ))}
            </Select>
          </Grid2>
        </Grid2>
        {errors.openers && <p className="error">{errors.openers}</p>}
      </Box>

      <Box className="dashboard-container" px={10}>
        <Typography className="form-title">Award Bid</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="awardee1">Final Approver 1</label>
            <Select
              name="awardee1"
              id="awardee1"
              value={awardees.awardee1}
              renderValue={(selected) => {
                const selectedUser = orgUsers?.find(
                  (user) => user.email === selected
                );
                return selectedUser?.name || "Choose";
              }}
              onChange={handleAwardeeChange}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "1px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {awardees.awardee1 === "" && <MenuItem value="">Choose</MenuItem>}
              {awardees.awardee1 !== "" && (
                <MenuItem value={awardees.awardee1} disabled>
                  {awardeesName.awardee1}
                </MenuItem>
              )}
              {orgUsers &&
                orgUsers
                  .filter(
                    (user) =>
                      (user.userRoleName === "COO" ||
                        user.userRoleName === "CFO" ||
                        user.userRoleName === "CMD") &&
                      user.email !== awardees.awardee2 &&
                      user.email !== awardees.awardee1
                  )
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="awardee2">Final Approver 2</label>
            <Select
              className={`${errors?.awardee2 && "input-error"}`}
              name="awardee2"
              id="awardee2"
              value={awardees.awardee2}
              renderValue={(selected) => {
                const selectedUser = orgUsers?.find(
                  (user) => user.email === selected
                );
                return selectedUser?.name || "Choose";
              }}
              onChange={handleAwardeeChange}
              IconComponent={() => <KeyboardArrowDownIcon fontSize="small" />}
              MenuProps={MenuProps}
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "1px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              {awardees.awardee2 === "" && <MenuItem value="">Choose</MenuItem>}
              {awardees.awardee2 !== "" && (
                <MenuItem value={awardees.awardee2} disabled>
                  {awardeesName.awardee2}
                </MenuItem>
              )}
              {orgUsers &&
                orgUsers
                  .filter(
                    (user) =>
                      (user.userRoleName === "COO" ||
                        user.userRoleName === "CFO" ||
                        user.userRoleName === "CMD") &&
                      user.email !== awardees.awardee2 &&
                      user.email !== awardees.awardee1
                  )
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
            {errors?.awardee2 && <p className="error">{errors?.awardee2}</p>}
          </Grid2>
        </Grid2>
      </Box>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack} disabled={btnLoading}>
          Back
        </Button>
        <Button className="btn-contained" onClick={handleNext} disabled={btnLoading}>
          Submit
        </Button>
      </Box>

      <SuccessModal
        open={open}
        handleClose={handleClose}
        msg={msg}
        nav={"/dashboard"}
      />
    </div>
  );
};

export default EditTenderApprover;
